/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace Application
 */
export class Application {
    init(language, country, baseUrl, isAssessmentApp=false) {
        let tempRunConfig = {
            assessmentApp: isAssessmentApp,
            language: language,
            country: country,
            baseUrl: baseUrl
        };
        localStorage.setItem("run-config", JSON.stringify(tempRunConfig));
        console.log("Initialized application.");
    }
    initFromUrl() {
        console.log("Initializing application from url.");
        let url = window.location.href;
        let arr = url.split("/");
        let language;
        let country;
        // loop through the array until you get xx_XX or /xx/ which indicates the language
        for (let i=0; i < arr.length; i++) {
            let part = arr[i];
            if (part.match(/[a-z][a-z]_[A-Z][A-Z]/)) {
                let parts = part.split("_");
                language = parts[0];
                country = parts[1];
            } else if (part.match(/[a-z][a-z]/)) {
                if (part.isalanguage) {
                    language = part;
                }
            }
        }

        if (!country && !language) {
            // search for just language

        }

        let baseUrl = arr[0] + "//" + arr[2];
        if (!baseUrl || !language || !country) {
            throw "Could not parse init params from url:"+window.location.href;
        } else {
            console.log("Extracted params from url. baseUrl:"+baseUrl+" language:"+language+" country:"+country);
        }
        this.init(language,country, baseUrl);
    }
}
